import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getPendingSlots, destroyContributionsForSlot, getGameSlotStatement } from '../../../api/ContributionsAPI';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppPaginator from '../../AppPaginator';
import AppToaster from '../../../components/AppToaster';



const ContributionsPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const successMessage = location.state?.message;

    const [slotsList, setSlotsList] = useState({ data: [], last_page: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [triggerFetch, setTriggerFetch] = useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    useEffect(() => {
        if (successMessage) {
            setShowToaster(true);
            setToaster({ type: 'success', heading: 'Success!', message: successMessage });
            navigate(location.pathname, { replace: true });
        }
    }, [successMessage, location.pathname, navigate]);

    useEffect(() => {
        setIsLoading(true);
        // Using getPendingSlots as it's the correct API for this page's purpose
        getPendingSlots({ page: currentPage }, (response) => {
            setIsLoading(false);
            if (response.booking_slots) {
                setSlotsList(response.booking_slots);
            }
        });
    }, [currentPage, triggerFetch]);

    const handleGenerateClick = (slotId) => {
        navigate(`/club_portal/contributions/create/${slotId}`);
    };

    const handleEditClick = (slotId) => {
        navigate(`/club_portal/contributions/edit/${slotId}`);
    };

    const handleDeleteClick = (slot) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `This will delete all contributions for the booking slot on <strong>${slot.slot_date}</strong>. This action cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete them!'
        }).then((result) => {
            if (result.isConfirmed) {
                destroyContributionsForSlot(slot.id, (res) => {
                    if (res.success) {
                        Swal.fire('Deleted!', 'All contributions for this slot have been deleted.', 'success');
                        setTriggerFetch(p => !p);
                    } else {
                        Swal.fire('Error!', 'Could not delete contributions.', 'error');
                    }
                });
            }
        });
    };
    const handleViewStatementClick = (slotId) => {
        navigate(`/club_portal/contributions/statement/${slotId}`);
    };

  

    return (
        <main>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <div className="container-fluid">
                <AppBreadCrumb title="Manage Contributions" />
                <div className="card">
                    <div className="card-header">
                        <h5>Select a Booking Slot</h5>
                        <small className="text-muted">Manage financial contributions for each individual playing session.</small>
                    </div>
                    <div className="card-body">
                        {isLoading ? (
                            <div className="text-center"><div className="spinner-border"></div></div>
                        ) : slotsList.data.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Time</th>
                                            <th>Venue</th>
                                            <th>Cost</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {slotsList.data.map(slot => (
                                            <tr key={slot.id}>
                                                <td>{slot.slot_date}</td>
                                                <td>{slot.start_time} - {slot.end_time}</td>
                                                <td>{slot.turf_booking.venue.name}</td>
                                                <td>₹{slot.cost}</td>
                                                <td>
                                                    {slot.contributions_count > 0
                                                        ? <span className="badge bg-success">Generated</span>
                                                        : <span className="badge bg-warning text-dark">Pending</span>
                                                    }
                                                </td>
                                                <td>
                                                    {slot.contributions_count > 0 ? (
                                                        <>
                                                            <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => handleViewStatementClick(slot.id)}>
                                                                <span className='d-none d-md-inline'>View Statement</span> <span className='d-md-none'>View </span>
                                                            </button>
                                                            <button className="btn btn-outline-primary btn-sm me-2" onClick={() => handleEditClick(slot.id)}>Edit</button>
                                                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleDeleteClick(slot)}>Delete</button>
                                                        </>
                                                    ) : (
                                                        <button className="btn btn-primary btn-sm" onClick={() => handleGenerateClick(slot.id)}>Generate</button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p>No booking slots are pending for contribution generation.</p>
                        )}
                        <AppPaginator totalPages={slotsList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ContributionsPage;

